<template>
  <div>
    <el-row :gutter="24">
      <el-col :span="12">
        <el-card class="box-card">
          <div class="card_title">首页</div>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('数据展示','/HomePage')">数据展示</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('异常提醒','/ExceptionReminder')">异常提醒</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('复查提醒','/ReviewReminder')">复查提醒</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('最后区间提醒','/LastIntervalReminder')">最后区间提醒</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('设备异常提醒','/DeviceExceptionReminder')">设备异常提醒</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('消息中心','/MessageCenter')">消息中心</el-button>
        </el-card>
      </el-col>

      <el-col :span="12">
        <el-card class="box-card">
          <div class="card_title">工作台&系统设置</div>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('我的工作台','/Workbenchsingle')">我的工作台</el-button>
          <el-button type="danger" size="mini" @click="clickQuickNavigation('工作台统计','/Workbenchstatistical')">工作台统计</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('机构管理','/Organizational')">机构管理</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('角色管理','/Role')">角色管理</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('管理员','/Admins')">管理员</el-button>
          <el-button type="danger" size="mini" @click="clickQuickNavigation('人脸识别','/FaceidLogs')">人脸识别</el-button>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="24">
      <el-col :span="12">
        <el-card class="box-card">
          <div class="card_title">客户&设备</div>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('客户管理','/CustomerManagement')">客户管理</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('训练数据','/TrainingData')">训练数据</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('下行数据','/DownLinkData')">下行数据</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('采集数据','/DataCollection')">采集数据</el-button>
          <el-button type="danger" size="mini" @click="clickQuickNavigation('意见反馈','/Feedback')">意见反馈</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('疑难解答','/Qa')">疑难解答</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('客户续费订单','/CustomerRenewalOrder')">客户续费订单</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('设备管理','/DeviceManagement')">设备管理</el-button>
        </el-card>
      </el-col>

      <el-col :span="12">
        <el-card class="box-card">
          <div class="card_title">统计与监控</div>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('每天佩戴统计','/Daily')">每天佩戴统计</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('训练数据分析','/TrainingDataAnalysis')">训练数据分析</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('图形化年报表','/AnnualReport')">图形化年报表</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('用户佩戴天数统计','/WearingDays')">用户佩戴天数统计</el-button>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="24">
      <el-col :span="12">
        <el-card class="box-card">
          <div class="card_title">运营商</div>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('运营商采购','/ErpDlsOrder')">运营商采购</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('运营商销售','/ErpDlsSales')">运营商销售</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('协议模板','/AgreementTemplate')">协议模板</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('已签署协议','/AgreementBackup')">已签署协议</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('门店所有人','/StoreOwner')">门店所有人</el-button>
          <el-button type="danger" size="mini" @click="clickQuickNavigation('门店提现审批','/WithdrawalApproval')">门店提现审批</el-button>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="box-card">
          <div class="card_title">内部文件管理</div>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('合同','/NeiBuFile1')">合同</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('人事合同','/NeiBuFile2')">人事合同</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('合作协议','/NeiBuFile3')">合作协议</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('保密协议','/NeiBuFile4')">保密协议</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('运营商合同','/NeiBuFile5')">运营商合同</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('加盟合作商合同','/NeiBuFile6')">加盟合作商合同</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('股东协议','/NeiBuFile7')">股东协议</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('其他','/NeiBuFile8')">其他</el-button>
        </el-card>
      </el-col>
    </el-row>

    <el-row :gutter="24">
      <el-col :span="12">
        <el-card class="box-card">
          <div class="card_title">访客登记&审批</div>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('访客登记','/Visitorslog')">访客登记</el-button>
          <el-button type="danger" size="mini" @click="clickQuickNavigation('报销','/ShenPiBaoXiao')">审批报销</el-button>
          <el-button type="danger" size="mini" @click="clickQuickNavigation('费用','/ShenPiFeiYong')">审批费用</el-button>
          <el-button type="danger" size="mini" @click="clickQuickNavigation('用章','/ShenPiYongZhang')">审批用章</el-button>
          <el-button type="danger" size="mini" @click="clickQuickNavigation('请假','/ShenPiQingJia')">审批请假</el-button>
          <el-button type="danger" size="mini" @click="clickQuickNavigation('出差','/ShenPiChuChai')">审批出差</el-button>
          <el-button type="danger" size="mini" @click="clickQuickNavigation('招聘','/ShenPiZhaoPin')">审批招聘</el-button>
        </el-card>
      </el-col>

      <el-col :span="12">
        <el-card class="box-card">
          <div class="card_title">生产&财务&人事</div>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('采购订单','/MadeOrder')">采购</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('库存管理','/KucunManagement')">库存管理</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('库存统计','/Productinventory')">库存统计</el-button>
          <el-button type="danger" size="mini" @click="clickQuickNavigation('资产负债表','/ReportZiChanFuZhai')">资产负债</el-button>
          <el-button type="danger" size="mini" @click="clickQuickNavigation('利润表','/ReportLiRun')">利润表</el-button>
          <el-button type="danger" size="mini" @click="clickQuickNavigation('明细账','/ReportMingXi')">明细账</el-button>
          <el-button type="danger" size="mini" @click="clickQuickNavigation('银行现金日记账','/ReportBankCashJournal')">日记账</el-button>
          <el-button type="danger" size="mini" @click="clickQuickNavigation('薪资社保公积金','/RenShi1')">薪资</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('发布公告','/Gonggao')">公告</el-button>
          <el-button plain type="primary" size="mini" @click="clickQuickNavigation('员工考勤','/RenShi5')">考勤</el-button>
        </el-card>
      </el-col>
    </el-row>

    <!-- 弹出框 -->
    <el-dialog title="未读消息(请到消息中心查看详情)" :visible.sync="displaydialog" width="30%" :close-on-click-modal="false">
      <el-form :model="messageForm" ref="messageFormRef" label-width="70px">
        <el-form-item label="" class="addAdminForm">
          <p v-for="item in messagelist"> 标题： {{item.Title}}</p>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 弹出框 end -->

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  name: 'MyHomeForLeader',
  data () {
    return {
      displaydialog: false,
      messageForm: {},
      messagelist: []
    }
  },
  mounted () {
    this.apiGetMessageCenterUnreadList()
  },
  methods: {
    clickQuickNavigation: function (menuname, key) {
      Event.$emit('clickQuickNavigation', menuname, key)
    },
    apiGetMessageCenterUnreadList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetMessageCenterUnreadList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.messagelist = response.data.List
            if (that.messagelist.length > 0) {
              that.displaydialog = true
            } else {
              that.displaydialog = false
            }
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.box-card{
    margin-top: 20px;
    background: #FFF;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}
.card_title{
    font-size: 16px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
}
</style>
